import { Http, RequestOptions, Headers } from '@angular/http';
import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { Router } from '@angular/router';
import { ContactUsForm } from './contact-us';
import 'rxjs/add/operator/toPromise';
import { delay } from 'q';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html'
})
export class ContactUsComponent implements OnInit {

  constructor(private toastr: ToastsManager, private router: Router, private http:Http) { }

  public submittingContactForm: boolean = false;
  public loadingFacebook: boolean = false;

  ngOnInit() {
  }

  async submit() {
    //submission code here    
    this.submittingContactForm = true;
    await this.delay();
    let headers = new Headers({ 'Content-Type': 'application/json'});
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'POST');
    headers.append('Access-Control-Allow-Origin', 'http://yqiq.co.za/api.php');
    headers.append('Access-Control-Allow-Origin', 'http://localhost:4200');
    let options = new RequestOptions({ headers: headers });
    let form = new ContactUsForm((<HTMLInputElement>document.getElementById("name")).value, (<HTMLInputElement>document.getElementById("email")).value, (<HTMLInputElement>document.getElementById("cellphone")).value, (<HTMLInputElement>document.getElementById("message")).value);
    this.http.post('/api.php', JSON.stringify(form), options).toPromise().then(res => {
      this.submittingContactForm = false;
      if (res)
      {        
        (<HTMLInputElement>document.getElementById("name")).value = "";
        (<HTMLInputElement>document.getElementById("email")).value = "";
        (<HTMLInputElement>document.getElementById("cellphone")).value = "";
        (<HTMLInputElement>document.getElementById("message")).value = "";
        this.router.navigate(['home']);
      }
    })
    .catch( error => { console.error(error) });
    
  }

  delay() {
    return new Promise( resolve => setTimeout(resolve, 2000) );
  }
}



// WEBPACK FOOTER //
// J:/Develop/Plumit Maintenance/src/app/contact-us/contact-us.component.ts